import { Component, OnInit } from '@angular/core';
import { LocationDto } from 'src/app/models/LocationDto';
import { AxiomsService } from 'src/app/services/axiom.service';

@Component({
  selector: 'app-view-axiom',
  templateUrl: './view-axiom.component.html',
  styleUrls: ['./view-axiom.component.css']
})
export class ViewAxiomComponent implements OnInit {

  constructor(private axiomService: AxiomsService) { }

 axioms:LocationDto[]|undefined;
  ngOnInit(): void {
    this.loadRecords();

  }


 async  loadRecords()
  {
    
    let  resLocations = await this.axiomService.getAxioms().toPromise(); 
    this.axioms = <LocationDto[]> resLocations.responseData;

  }

}
